import { render, staticRenderFns } from "./TaskCreateDialog.vue?vue&type=template&id=b4d3026e&scoped=true&"
import script from "./TaskCreateDialog.vue?vue&type=script&lang=js&"
export * from "./TaskCreateDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskCreateDialog.vue?vue&type=style&index=0&id=b4d3026e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d3026e",
  null
  
)

export default component.exports